// extracted by mini-css-extract-plugin
export default {"root":"HelpText_root__8PuDI textSmall"};